import PermsItem from './permsItem';

/**
  Class to build permissions object
 */
export default class PermsBuilder {
  constructor() {
    this.permissions = {};
  }

  /**
   * Register permission item
   * @param {string} action action
   * @param {boolean | Array} perms boolean or user groups
   */
  add = (action, perms) => {
    this.permissions[action] = new PermsItem(perms);
  };

  /**
   * Adds a rule to the permission check
   * @param {string} action action
   * @param {function} func custom rule function
   */
  addRule = (action, func) => {
    this.permissions[action].addRule(func);
  };

  /**
   * Returns permission
   * @returns {object} permissions object
   */
  getPerms = () => {
    return this.permissions;
  };
}
